import React from "react";
import logo from "../assets/imgs/logo.png";

const Loader = () => {
  return (
    <section className="fixed inset-0 bg-white/90 flex justify-center items-center z-50">
      <img
        src={logo}
        alt="loader_logo"
        className="w-16 sm:w-20 md:w-24 lg:w-28 animate-pulse object-contain"
      />
    </section>
  );
};

export default Loader;
